'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Private Members
var keys = Symbol('Keys collection');

var set = Symbol('This private method will be used to set a value');
var get = Symbol('This private method will be used to get a value');
var remove = Symbol('This private method will be used to remove a value');
var setObject = Symbol('This private method will be used to set an object');
var getObject = Symbol('This private method will be used to get an object');
var isJsonString = Symbol('This private method will be used to check if the string value is a JSON string');

var Locker = function () {
  function Locker() {
    _classCallCheck(this, Locker);

    this[keys] = [];
  }

  _createClass(Locker, [{
    key: set,
    value: function value(key, _value) {
      sessionStorage.setItem(key, _value);
      this[keys].push(key);
    }
  }, {
    key: get,
    value: function value(key) {
      return sessionStorage.getItem(key);
    }
  }, {
    key: remove,
    value: function value(key) {
      sessionStorage.removeItem(key);
      this[keys] = this[keys].filter(function (item) {
        return item !== key;
      });
    }
  }, {
    key: setObject,
    value: function value(key, obj) {
      if (obj) {
        this[set](key, JSON.stringify(obj));
      }
    }
  }, {
    key: getObject,
    value: function value(key) {
      var json = this[get](key);
      if (json) {
        return JSON.parse(json);
      }
      return null;
    }
  }, {
    key: isJsonString,
    value: function value(input) {
      try {
        JSON.parse(input);
        return true;
      } catch (ex) {
        return false;
      }
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        this[setObject](key, value);
      } else {
        this[set](key, value);
      }
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      var value = this[get](key);

      if (this[isJsonString](value)) {
        return this[getObject](key);
      } else {
        return this[get](key);
      }
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      this[remove](key);
    }
  }, {
    key: 'getKeys',
    value: function getKeys() {
      return this[keys];
    }
  }]);

  return Locker;
}();

exports.default = Locker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ctxs-vue-plugins/dist/classes/Locker.js
// module id = HWei
// module chunks = 0